import styled from "styled-components";

const NavbarStyled = styled.div`
  .profile-info {
    width: auto;
  }
`;

export default NavbarStyled;
